<!-- app-home.component.html -->

<div class="app-container">
  <!-- TOP APP HEADER -->
  <app-header [isAdmin]="false" (logoutEvent)="onLogout()" (loginEvent)="onLogin()">
  </app-header>

  <!-- MAIN CONTENT: Single Tree Mode -->
  <div class="app-content" [class.single-tree-mode]="true"
       [class.horizontal-tabs-mode]="showHorizontalTabs"
       [class.mobile-nav-visible]="showMobileNav" [class.mobile-details-visible]="showMobileDetails">

    <!-- Overlay for mobile view to capture clicks on the 20% visible area -->
    <div *ngIf="showMobileNav && isMobileView" class="mobile-nav-overlay" (click)="toggleMobileNav()"></div>

    <!-- Horizontal Tabs Container (shown above everything when enabled) -->
    <ng-container *ngIf="showHorizontalTabs && singleTreeComponent">
        <div class="horizontal-tabs-global-container">
            <div class="horizontal-tabs-container">
                <div class="tabs-wrapper">
                    <div class="tabs-row">
                        <!-- Toggle Button to switch back to tree view -->
                        <button
                            mat-icon-button
                            class="horizontal-toggle-back-button"
                            (click)="singleTreeComponent.toggleHorizontalView()"
                            matTooltip="Switch to Tree View">
                            <mat-icon>view_sidebar</mat-icon>
                        </button>
                        
                        <div class="tab-item" 
                             *ngFor="let subject of singleTreeComponent.getSubjectsForTabs(); let i = index"
                             [class.active]="selectedSubject === subject.name"
                             [class.hovered]="singleTreeComponent.hoveredTabIndex === i"
                             (mouseenter)="singleTreeComponent.onTabMouseEnter(i)"
                             (mouseleave)="singleTreeComponent.onTabMouseLeave()"
                             (click)="singleTreeComponent.onTabItemClick(subject)">
                            <span class="tab-text" [innerHTML]="singleTreeComponent.formatNodeName(subject.name, subject.nameHindi || hindiNameMap[subject.name] || subject.name)"></span>
                            <mat-icon class="dropdown-arrow" *ngIf="singleTreeComponent.getSubjectChildren(subject).length > 0">arrow_drop_down</mat-icon>
                        </div>
                    </div>

                    <!-- Dropdown Content -->
                    <div class="dropdown-overlay" *ngIf="singleTreeComponent.activeDropdownIndex !== null">
                        <div class="dropdown-content"
                             (mouseenter)="singleTreeComponent.onDropdownMouseEnter()"
                             (mouseleave)="singleTreeComponent.onDropdownMouseLeave()">
                            <ng-container *ngFor="let subject of singleTreeComponent.getSubjectsForTabs(); let i = index">
                                <div class="dropdown-panel" *ngIf="singleTreeComponent.activeDropdownIndex === i">
                                    <div class="dropdown-header">
                                        <h4 [innerHTML]="singleTreeComponent.formatNodeName(subject.name, subject.nameHindi || hindiNameMap[subject.name] || subject.name)"></h4>
                                    </div>
                                    <div class="dropdown-items">
                                        <div class="dropdown-section" *ngFor="let child of singleTreeComponent.getSubjectChildren(subject)">
                                            <div class="dropdown-item"
                                                 [class.selected]="singleTreeComponent.selectedNodePath.includes(child)"
                                                 (click)="singleTreeComponent.onTabItemClick(child)">
                                                <span [innerHTML]="singleTreeComponent.formatNodeName(child.name, child.nameHindi || hindiNameMap[child.name] || child.name)"></span>
                                            </div>
                                            <!-- Show children of sections/topics -->
                                            <div class="dropdown-sub-items" *ngIf="child.children && child.children.length > 0">
                                                <div class="dropdown-sub-item"
                                                     *ngFor="let subChild of child.children"
                                                     [class.selected]="singleTreeComponent.selectedNodePath.includes(subChild)"
                                                     (click)="singleTreeComponent.onTabItemClick(subChild)">
                                                    <span [innerHTML]="singleTreeComponent.formatNodeName(subChild.name, subChild.nameHindi || hindiNameMap[subChild.name] || subChild.name)"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>

    <!-- Single Tree Component (hidden when horizontal tabs are active) -->
    <app-single-tree #singleTreeComponent
                 [p1Mode]="p1Mode"
                 [p1Subjects]="p1Subjects"
                 [p1SubMap]="p1SubMap"
                 [p1YearwiseExams]="p1YearwiseExams"
                 [p1YearwiseLower]="p1YearwiseLower"
                 [p2Years]="p2Years"
                 [hindiNameMap]="hindiNameMap"
                 [isLoadingSubjects]="isLoadingSubjects"
                 [isLoadingSections]="isLoadingSections"
                 [isLoadingTopics]="isLoadingTopics"
                 [isLoadingSubtopics]="isLoadingSubtopics"
                 [p2TopicsMap]="p2TopicsMap"
                 [p2SubTopicsMap]="p2SubTopicsMap"
                 [topicIdMap]="topicIdMap"
                 [isInternalUser]="isInternalUser"
                 [searchTerm]="searchTerm"
                 [filterMode]="filterMode"
                 [horizontalView]="showHorizontalTabs"
                 [class.horizontal-mode]="showHorizontalTabs"
                 [style.display]="showHorizontalTabs ? 'none' : 'flex'"
                 (modeChange)="onP1ModeChange($event)"
                 (subjectClick)="onSubjectSelect($event)"
                 (subItemClick)="onSubItemSelect($event)"
                 (topicClick)="onTopicSelect($event)"
                 (subTopicClick)="onSubTopicSelect($event)"
                 (yearwiseExamClick)="onYearwiseExamSelect($event)"
                 (yearwiseLowerClick)="onYearwiseLowerSelect($event)"
                 (yearClick)="onYearSelect($event)"
                 (hindiNamesRequested)="loadHindiNamesForUI()"
                 (topicsLoaded)="onTopicsLoaded($event)"
                 (subtopicsLoaded)="onSubtopicsLoaded($event)"
                 (languageChange)="onLanguageChange($event)"
                 (yearsListGenerated)="onYearsListGenerated($event)"
                 (hierarchyPathChange)="onHierarchyPathChange($event)"
                 (showAllBundlesClick)="onShowAllBundles()"
                 (adminModeChange)="onAdminModeChange($event)"
                 (subjectsRefreshed)="onSubjectsRefreshed()"
                 (horizontalViewChange)="onHorizontalViewChange($event)"
                 (blogModeChange)="onBlogModeChange($event)"
                 (changeNavViewChange)="onChangeNavViewChange($event)">
      <app-layout-switcher
        [hideSearch]="true"
        [isMobileView]="isMobileView"
        (layoutChange)="onLayoutChange($event)">
      </app-layout-switcher>
    </app-single-tree>

    <!-- Vertical Resizable Divider between tree and main content -->
    <div class="vertical-divider"
         *ngIf="!showHorizontalTabs"
         (mousedown)="onNavDividerMouseDown($event)"
         (dblclick)="resetNavPanelSize()"
         [class.dragging]="isNavDragging"
         [class.active]="isNavDragging"
         [class.user-select-none]="isNavDragging"
         title="Drag to resize or double-click to reset">
    </div>

    <!-- Main content wrapper -->
    <div class="single-tree-content" [class.full-width]="showHorizontalTabs" [class.blog-mode]="blogMode">
      
      <!-- Blog Home Component - Show when blog mode is enabled -->
      <app-blog-home #blogHomeComponent
        *ngIf="blogMode"
        [style.flex]="showDetails ? blogHomeAreaFlex : '1 1 auto'"
        [style.width]="showDetails ? null : '100%'"
        [selectedTopicFromTree]="selectedTopic"
        [selectedSubjectFromTree]="selectedSubject"
        [selectedSectionFromTree]="selectedSubItem"
        [isBlogMode]="blogMode"
        [isFloatingHeaderMode]="changeNavView"
        [hideInternalNavigation]="true"
        class="blog-home-area">
      </app-blog-home>
      
      <!-- Main Area Component (Pane 3) -->
      <app-main-area #mainAreaComponent
        *ngIf="(showMains || mainAreaFlex !== '0 0 0%') && !blogMode"
        [style.flex]="showDetails ? mainAreaFlex : '1 1 auto'"
        [style.width]="showDetails ? null : '100%'"
        [p1Mode]="p1Mode"
        [selectedSubject]="selectedSubject"
        [selectedSubItem]="selectedSubItem"
        [selectedTopic]="selectedTopic"
        [selectedSubTopic]="selectedSubTopic"
        [selectedYearwiseExam]="selectedYearwiseExam"
        [selectedYearwiseLower]="selectedYearwiseLower"
        [selectedYear]="selectedYear"
        [loadedQuestions]="loadedQuestions"
        [isLoadingQuestions]="isLoadingTopicQuestions"
        [isMobileView]="isMobileView"
        [isInternalUser]="isInternalUser"
        [hindiNameMap]="hindiNameMap"
        (toggleMobileNav)="toggleMobileNav()"
        (selectedCardChange)="onSelectedCardChange($event)"
        (showDetailsChange)="onShowDetailsChange($event)"
        (viewModeChange)="onViewModeChange($event)">
      </app-main-area>

      <!-- Vertical Resizable Divider - Only show if details are visible and not in popup mode -->
      <div *ngIf="showDetails && ((showMains || mainAreaFlex !== '0 0 0%') || blogMode) && mainAreaFlex !== '0 0 12.5%'" class="vertical-divider"
           (mousedown)="onMouseDown($event)"
           (dblclick)="resetPanelSizes()"
           [class.dragging]="isDragging"
           [class.active]="isDragging"
           [class.user-select-none]="isDragging"
           title="Drag to resize or double-click to reset">
      </div>

      <!-- Details Area Component (Pane 4) - Only show if showDetails is true -->
      <app-details-area
        *ngIf="showDetails && mainAreaFlex !== '0 0 12.5%'"
        [style.flex]="blogMode ? blogDetailsAreaFlex : (showMains ? detailsAreaFlex : '1 1 auto')"
        [style.width]="showMains ? null : '100%'"
        [selectedCard]="selectedCard"
        [isFullscreenMode]="mainAreaFlex === '0 0 0%'"
        [showMains]="showMains"
        [isMobileView]="isMobileView"
        [fileLoading]="!!mainAreaComponent?.fileLoading"
        (backToMain)="backToMainFromDetails()"
        (viewModeChange)="onViewModeChange($event)"
        (showMainsChange)="onShowMainsChange($event)"
        (hideDetails)="onHideDetails()">
      </app-details-area>
    </div>

    <!-- Pop-up Details Area - Only show in popup mode -->
    <app-details-area
      *ngIf="showDetails && mainAreaFlex === '0 0 12.5%'"
      [ngClass]="'popup-mode'"
      [selectedCard]="selectedCard"
      [isFullscreenMode]="false"
      [showMains]="showMains"
      [isMobileView]="isMobileView"
      [fileLoading]="!!mainAreaComponent?.fileLoading"
      (backToMain)="backToMainFromDetails()"
      (viewModeChange)="onViewModeChange($event)"
      (showMainsChange)="onShowMainsChange($event)"
      (hideDetails)="onHideDetails()">
    </app-details-area>

    <!-- Reset notification (visible only briefly when panels are reset) -->
    <div class="reset-notification" *ngIf="showResetNotification">
      Panel sizes reset to default
    </div>

    <!-- Preloading Overlay - shown while data is being loaded initially -->
    <div class="preloading-overlay" *ngIf="isPreloading">
      <div class="preloading-container">
        <mat-spinner [diameter]="64" [strokeWidth]="6" color="primary"></mat-spinner>
        <div class="preloading-text">Loading Subjects...</div>
        <div class="preloading-subtext">Please wait while we prepare your content...</div>
      </div>
    </div>
  </div>

  <!-- <app-footer></app-footer> -->
</div>
